import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Alert, TableSortLabel, Typography } from "@mui/material";
import {
  typography,
  spacing,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface Props {
  weeksTableHeadings: { [key: string]: string };
  weeksTableRows: any[];
}

const RecentWeeksTable = ({ weeksTableHeadings, weeksTableRows }: Props) => {
  const headCells = Object.entries(weeksTableHeadings);

  const parsePlusMinus = (value: unknown): "success" | "error" | null => {
    if (typeof value === "string") {
      if (value.trim().startsWith("-")) return "error";
      if (value.trim().startsWith("+")) return "success";
    }
    return null;
  };
  const getPlusMinusAlertConfig = (type: "success" | "error") => {
    if (type === "error") {
      return {
        severity: "error" as const,
        color: colors.Error[600].$value,
        icon: false,
      };
    }

    return {
      severity: "success" as const,
      color: colors.Success[600].$value,
      icon: false,
    };
  };

  return (
    <>
      <Table size="small">
        <TableHead sx={{ background: colors.GrayLightMode[100].$value }}>
          <TableRow>
            {headCells.map(([_, value], index) => (
              <TableCell
                key={index}
                align="left"
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: typography.Size.Text.xs.$value,
                  fontWeight: typography.Font_weight.Regular.$value,
                  paddingX: spacing.Spacing.sm.$value,
                }}
              >
                <TableSortLabel>
                  {value && typeof value === "string" ? value : ""}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {weeksTableRows.map((row) => (
            <React.Fragment key={row.cron_id}>
              <TableRow
                sx={{
                  "& > *": {
                    borderBottom:
                      "1px solid " +
                      colors.GrayLightMode[200].$value +
                      "!important",
                  },
                }}
              >
                {headCells.map(([key], cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    align="left"
                    sx={{
                      // whiteSpace: "nowrap",
                      fontSize: typography.Size.Text.xs.$value,
                      fontWeight: typography.Font_weight.Regular.$value,
                      paddingX: spacing.Spacing.sm.$value,
                      paddingY: spacing.Spacing.xxs.$value,
                    }}
                  >
                    {key === "metric" ? (
                      <> {row[key] ? row[key] : "N/A"}</>
                    ) : key === "last_7_days" ? (
                      <Typography
                        sx={{
                          fontWeight: typography.Font_weight.Bold.$value,
                          fontSize: typography.Size.Text.xs.$value,
                        }}
                      >
                        {" "}
                        {row[key] ? row[key] : "N/A"}
                      </Typography>
                    ) : key === "days_7_14" ? (
                      <Typography
                        sx={{
                          fontWeight: typography.Font_weight.Bold.$value,
                          fontSize: typography.Size.Text.xs.$value,
                        }}
                      >
                        {" "}
                        {row[key] ? row[key] : "N/A"}
                      </Typography>
                    ) : key === "trend" ? (
                      <div className="AlertItems">
                        {(() => {
                          const type = parsePlusMinus(row[key]);

                          if (!type) return <>N/A</>;

                          const { severity, color, icon } =
                            getPlusMinusAlertConfig(type);

                          return (
                            <Alert
                              icon={icon}
                              severity={severity}
                              sx={{
                                color: `${color}`,
                                fontWeight:
                                  typography.Font_weight.Medium.$value,
                                paddingX: spacing.Spacing.sm.$value,
                                fontSize: typography.Size.Text.xs.$value,
                                paddingY:
                                  spacing.Spacing.none.$value + "!important",
                                display: "inline-flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {row[key]}
                            </Alert>
                          );
                        })()}
                      </div>
                    ) : (
                      "N/A"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </React.Fragment>
          ))}
        </TableBody>
      </Table>
    </>
  );
};

export default RecentWeeksTable;
